const MRetailManager = [
  {
    title: 'Dashboard',
    is_heading: false,
    is_active: false,
    link: {
      name: 'rm.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-objects-column',
    active_icon: 'fad fa-objects-column'
  }
]

const MROPurchaseOrders = [
  {
    title: 'Purchase Orders',
    is_heading: true,
    is_active: false,
    link: {
      name: 'rm.purchase-orders'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  {
    title: 'Approvals',
    is_heading: false,
    is_active: false,
    link: {
      name: 'rm.purchase-orders.approvals'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-cart-circle-check',
    active_icon: 'fad fa-cart-circle-check'
  }
  // {
  //   title: 'Requests',
  //   is_heading: false,
  //   is_active: false,
  //   link: {
  //     name: 'rm.purchase-orders.requests'
  //   },
  //   class_name: '',
  //   is_icon_class: true,
  //   icon: 'fat fa-cart-circle-plus',
  //   active_icon: 'fad fa-cart-circle-plus'
  // },
  // {
  //   title: 'Receiving',
  //   is_heading: false,
  //   is_active: false,
  //   link: {
  //     name: 'rm.purchase-orders.receiving'
  //   },
  //   class_name: '',
  //   is_icon_class: true,
  //   icon: 'fat fa-cart-circle-arrow-down',
  //   active_icon: 'fad fa-cart-circle-arrow-down'
  // }
]

const MROInterBranches = [
  {
    title: 'Inter Branches',
    is_heading: true,
    is_active: false,
    link: {
      name: 'rm.inter-branches'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  {
    title: 'Approvals',
    is_heading: false,
    is_active: false,
    link: {
      name: 'rm.inter-branches.approvals'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-cart-circle-check',
    active_icon: 'fad fa-cart-circle-check'
  }
]

export default MRetailManager.concat(
  MROPurchaseOrders,
  MROInterBranches
)
